import { AssetPresetStlModel } from "./asset_preset_stl.model";
import { RemedialModel } from "./remedial.model";

export class ObservationModel {

  uid: number;
  assetUid: number;
  observationInfo: string;
  conditionCode: string;
  chosenRemedials: Array<RemedialModel>;
  customRemedials: Array<RemedialModel>;
  observedDateTime: string;
  loggedByUser: string;
  assetName: string;
  concatRemedialNames: string;
  ref: string;

  repairedOnJobUid: number;
	repairedByUser: string;
  repairedDateTime: string;
  repairNotes: string;

  recommendedOnJobUid: number;
  recommendedByUser: string;
  recommendedDateTime: string;

  powerIssue: string;
  
  condemnAssetReuseParts: string;
  condemnAssetReusePartsText: string;
  condemnAssetIsolated: string;
  condemnFuseRemoved: string;
  condemnAssetSufficientLighting: string;
  condemnAssetDangerousPosition: string;
  condemnAssetDangerousPositionText: string;

  presetStlRemedialUids: Array<any>; // @Fil Can be removed once updated to use model below
  currentStlPresets: Array<AssetPresetStlModel> = [];

  observedDateTimeReadable: string;
  recommendedDateTimeReadable: string;
  repairedDateTimeReadable: string;

  recommendedJobInfo: string;
  repairedJobInfo: string;

  selected: boolean;

  constructor() {

  }
}